import UplayPlusVaultApi from "../api/UplayPlusVaultApi";

export default class GamesService {
    static getGames = (ticket: string, sessionId: string, locale: string) => {
        return UplayPlusVaultApi.get(
            `/v1/games?locale=${locale}`,
            {
                headers: {
                    'Ubi-AppId': process.env.REACT_APP_APP_ID,
                    'Authorization': `ubi_v1 t=${ticket}`,
                    "Ubi-SessionId": sessionId
                }
            }
        );
    };

    static getVault = (ticket: string, sessionId: string, locale: string) => {
        return UplayPlusVaultApi.get(
            `/v1/vault?locale=${locale}`,
            {
                headers: {
                    'Ubi-AppId': process.env.REACT_APP_APP_ID,
                    'Authorization': `ubi_v1 t=${ticket}`,
                    "Ubi-SessionId": sessionId
                }
            }
        );
    };

    static activateGame = (ticket: string, sessionId: string, gameId: number) => {
        return UplayPlusVaultApi.post(
            `/v1/games/activate/${gameId}`,
            null,
            {
                headers: {
                    'Ubi-AppId': process.env.REACT_APP_APP_ID,
                    'Authorization': `ubi_v1 t=${ticket}`,
                    "Ubi-SessionId": sessionId
                }
            }
        );
    };
}